import React from "react"
import { Link } from "gatsby"
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

import headerLogoImage from "../../images/header-logo.png"

const Header = () => (
  <header className="c-header">
    <img className="c-header__logo" src={headerLogoImage} alt="Logo" />

    <div className="c-top-bar">
      <div className="c-top-bar__row">
        <div className="c-top-bar__icon-container">
          <FaMapMarkerAlt className="c-top-bar__icon" />
        </div>
        <div>9620 174 Street NW — Edmonton, AB</div>
      </div>
      <div className="c-top-bar__divider"></div>
      <div className="c-top-bar__row">
        <div className="c-top-bar__icon-container">
          <FaPhoneAlt className="c-top-bar__icon" />
        </div>
        <a className="c-top-bar__phone" href="tel:+5875667197">(587) 566-7197</a>
      </div>
    </div>

    <nav className="c-nav">
      <ul className="c-nav__list">
        <li className="c-nav__item">
          <Link className="c-nav__link" to="/" activeClassName="is-active">home</Link>
        </li>
        <li className="c-nav__item">
          <Link className="c-nav__link" to="/products" activeClassName="is-active">products</Link>
        </li>
        <li className="c-nav__item">
          <Link className="c-nav__link" to="/contact" activeClassName="is-active">contact</Link>
        </li>
      </ul>
    </nav>

  </header>
)

export default Header